import React from "react";
import {Badge} from "antd";

interface AlertProps {
  count: number;
}

class AlertBadge extends React.Component<AlertProps, any> {
  public render() {
    return (
      <Badge
        count={this.props.count}
        overflowCount={99}
        offset={[12, -2]}
      />
    );
  }
}

export default AlertBadge;


// WEBPACK FOOTER //
// ./src/app/alert/AlertBadge.tsx